<!--Header-->
<div class="modal-header" style="border-bottom: none;">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="row">
        <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
          <h4 class="modal-title"><span id="ApntmntHdr" style="font-size: 22px;">Select Store</span></h4>
        </div>
        <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="passBack()"></i>
        </div>
      </div>
    </div> 
  </div>
  <!--Body-->
  <div class="modal-body" style="padding-top: 0px;">
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
      <div class="col-md-8 col-sm-8 col-8" style="display: inline-block; padding: 0px;">
        <select class="label Bluebadge form-control bzInput" [(ngModel)]="store.id" style="display: inline-block; font-size: 13px; background: inherit; cursor: pointer; padding: 5px;">
          <option *ngIf="isShowAllOption" value="0">{{ (AllOption && isFromInvList) ? 'Select Store' : (AllOption ? 'All' : 'Select')}}</option>
          <option *ngFor="let s of stores" [ngValue]="s.StrID">{{s.sNm}}</option>  
          <!-- <option value="0" selected *ngIf="allStoreCnt == stores.length">{{ (AllOption && isFromInvList) ? 'Select Store' : (AllOption ? 'All' : 'Select')}}</option>
          <option *ngFor="let s of stores" [ngValue]="s.StrID">{{s.sNm}}</option>   -->
          <!-- <option value="0" selected>Jaimin</option>
            <option value="1">Deep</option>
            <option value="2">Abhishek</option> -->
        </select>
      </div>
    </div>
    </div>
  <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn-darkGreen" style="border-radius: 3px !important; padding: 2px 10px;  font-size: 14px;" (click)="save()">
        <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
        <span>Select</span>
        </span>
    </div>
